import { useEffect, useState } from 'react';

import { usePageTitle } from '../hooks/usePageTitle';

interface WeatherForecast {
  date: string;
  temperatureC: number;
  summary?: string;
}

const toFahrenheit = (celsius: number) => 32 + Math.trunc(celsius / 0.5556);

const formatDate = (isoDate: string) => new Date(`${isoDate}T00:00:00`).toLocaleDateString();

export default function Weather() {
  usePageTitle('Weather');
  const [forecasts, setForecasts] = useState<WeatherForecast[] | null>(null);

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      const response = await fetch('/sample-data/weather.json');
      const data = (await response.json()) as WeatherForecast[];
      if (!cancelled) setForecasts(data);
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="container page-content py-5">
      <h1>Weather</h1>

      <p>This component demonstrates fetching data from the server.</p>

      {forecasts === null ? (
        <p>
          <em>Loading...</em>
        </p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th aria-label="Temperature in Celsius">Temp. (C)</th>
              <th aria-label="Temperature in Fahrenheit">Temp. (F)</th>
              <th>Summary</th>
            </tr>
          </thead>
          <tbody>
            {forecasts.map((forecast) => (
              <tr key={forecast.date}>
                <td>{formatDate(forecast.date)}</td>
                <td>{forecast.temperatureC}</td>
                <td>{toFahrenheit(forecast.temperatureC)}</td>
                <td>{forecast.summary}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
